<template>
  <div class="xmgl-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <div class="card-title">
            <div class="search-mode">
              <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
                <el-form-item label="项目状态">
                  <el-select v-model="searchForm.mark" style="width: 120px" filterable clearable>
                    <el-option label="平面图" :value="0"/>
                    <el-option label="效果图" :value="1"/>
                    <el-option label="施工图" :value="2"/>
                    <el-option label="施工交底" :value="3"/>
                    <el-option label="复尺" :value="4"/>
                    <el-option label="深化图纸" :value="5"/>
                    <el-option label="下单" :value="6"/>
                    <el-option label="验收" :value="9"/>
                    <el-option label="已完成" :value="100"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="搜索关键字">
                  <el-input v-model="searchForm.search" placeholder="请输入关键字" @keyup.enter.native="Search()"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button icon="el-icon-search" @click="Search()">搜索</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div v-loading="loading">
              <el-table
                :data="tableData"
                stripe
                style="width: 100%;margin-bottom: 20px">
                <el-table-column
                  prop="name"
                  label="项目名称"
                  width="160"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="remark"
                  label="项目说明"
                  min-width="160"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="createname"
                  label="创建人"
                  width="120"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="time"
                  label="创建时间"
                  width="160"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  label="状态"
                  width="100"
                  fixed="right"
                  show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div v-if="scope.row.mark===0">平面图</div>
                    <div v-if="scope.row.mark===1">效果图</div>
                    <div v-if="scope.row.mark===2">施工图</div>
                    <div v-if="scope.row.mark===3">施工交底</div>
                    <div v-if="scope.row.mark===4">复尺</div>
                    <div v-if="scope.row.mark===5">深化图纸</div>
                    <div v-if="scope.row.mark===6">下单</div>
                    <div v-if="scope.row.mark===9">验收</div>
                    <div v-if="scope.row.mark===100">已完成</div>
<!--                    <el-tag v-if="scope.row.mark===0" type="danger" :disable-transitions="true" size="mini">未开始</el-tag>-->
<!--                    <el-tag v-if="scope.row.mark>0&&scope.row.mark<100" type="success" :disable-transitions="true" size="mini">进行中</el-tag>-->
<!--                    <el-tag v-if="scope.row.mark===100" :disable-transitions="true" size="mini">已完成</el-tag>-->
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="100"
                  fixed="right"
                  show-overflow-tooltip>
                  <template slot-scope="scope">
<!--                    <el-dropdown size="mini" v-if="scope.row.userid===user.dUserid" split-button @click="editProject(scope.row)">-->
<!--                      <i class="el-icon-edit"></i> 修改-->
<!--                      <el-dropdown-menu slot="dropdown">-->
<!--                        <el-dropdown-item @click.native="deleteProject(scope.row)"><i class="el-icon-delete"></i> 删除</el-dropdown-item>-->
<!--                      </el-dropdown-menu>-->
<!--                    </el-dropdown>-->
                    <el-button icon="el-icon-document" size="mini" @click="projectDetail(scope.row)">详情</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-pagination
              v-if="total>0"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getBuildShopData } from '@/api/work'

export default {
  name: 'szjd',
  computed: {
    user: getUser
  },
  data() {
    return {
      searchForm: {
        search: '',
        mark: null
      },
      loading: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      // szVisible: false
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      const data = {
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        page: this.currentPage,
        limit: this.pageSize,
        content: this.searchForm.search,
        mark: this.searchForm.mark
      }
      getBuildShopData(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.loading = false
      })
    },
    Search() {
      this.getData()
    },
    deleteProject() { },
    editProject() { },
    projectDetail(row) {
      this.$router.push({
        path: `/work/szjd/${row.sid}`
      })
    },
    handleSizeChange() { },
    handleCurrentChange() { },
  }
}
</script>

<style scoped>

</style>
